export default __webpack_public_path__ + "static/tatum-e187efcb66a3b24931b17f853046ed95.png";